module.exports = __webpack_public_path__ + "MT.png?6465da94c46655e59c4025643e720768";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/MT.png
// module id = 384
// module chunks = 0